import { isFeatureEnabled } from 'owa-feature-flags';

export default function isReadingPaneCardUIEnabled(): boolean {
    return isFeatureEnabled('rp-cardUI');
}
